var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3994 11.6555C14.0028 10.6448 14.3494 9.46319 14.3494 8.20059C14.3494 4.47272 11.3274 1.45068 7.59952 1.45068C3.87165 1.45068 0.849609 4.47272 0.849609 8.20059C0.849609 11.9285 3.87165 14.9505 7.59952 14.9505C8.86488 14.9505 10.0489 14.6023 11.061 13.9965L14.2561 14.8527L13.3994 11.6555Z",
    stroke: "#0A0D12",
    strokeWidth: 1.03234,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.ccda043c0856e7e8c1144b171a9b63b3.svg";
export { ForwardRef as ReactComponent };